<template>
  <Library :data="data" @tabChange="formChange">
    <LoginForm
      v-if="currentForm === 'login'" slot="form" flashcards
      type="signup" @signup="formChange('signup')"
      @forgotten-password="formChange('forgottenPassword')"
    />
    <SignupForm
      v-if="currentForm === 'signup'" slot="form" flashcards
      type="login" @login="formChange('login')"
    />
    <ForgottenPassword
      v-if="currentForm === 'forgottenPassword'" slot="form" flashcards
      type="forgotten-password"
    />
  </Library>
</template>

<script>
import cookies from 'js-cookie';
import Library from '@itbpbg/lms-components/src/Flashcards/Library';
import global from '@itbpbg/lms-components/src/mixins/global';
import LoginForm from '../../components/LoginForm';
import SignupForm from '../../components/SignupForm';
import ForgottenPassword from '../../components/Flashcards/ForgottenPassword';

export default {
  components: {
    Library,
    LoginForm,
    SignupForm,
    ForgottenPassword,
  },
  mixins: [global],
  async asyncData({
    $axios, route, $config, store, $globalHelper, req, redirect,
  }) {
    const [data, page] = await Promise.all([
      $axios.$get('/flashcards?page=1&initial_data=1'),
      $axios.$get(`/pages${route.fullPath}`),
    ]);
    if (!store.state.auth.user) {
      let review;
      if (process.server) {
        const parsedCookies = $globalHelper.parseCookies(req.headers.cookie || '');
        review = parsedCookies.review_cards;
      } else {
        review = cookies.get('review_cards');
      }

      if (review) {
        const json = JSON.parse(review);
        data.decks.data.forEach((deck) => {
          // eslint-disable-next-line no-param-reassign
          deck.cookiesReviewed = json[deck.id] || 0;
          if (deck.cookiesReviewed) {
            // eslint-disable-next-line no-param-reassign
            deck.status = 'in-progress';
          }
        });
      }
    } else if (route.query.routePath && route.query.routePath.startsWith('flashcards')) {
      // catch case when user is signed up with Linkedin and returned here with query params for exact deck
      redirect(301, `/${decodeURIComponent(route.query.routePath)}`);
    }

    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    return { data, page };
  },
  data() {
    return {
      currentForm: 'login',
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
  methods: {
    formChange(currentForm) {
      this.currentForm = currentForm;
    },
  },
};
</script>
